import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = { class: "nav-content" }
const _hoisted_3 = { class: "nav-brand" }
const _hoisted_4 = { class: "nav-links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "brand-title"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("一杯吃吃的小窝")
          ])),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "nav-item"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "nav-icon" }, "🏠", -1),
            _createElementVNode("span", null, "主页", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/dynamic",
          class: "nav-item"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "nav-icon" }, "📢", -1),
            _createElementVNode("span", null, "动态", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/replay",
          class: "nav-item"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createElementVNode("i", { class: "nav-icon" }, "📺", -1),
            _createElementVNode("span", null, "录播", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/creation",
          class: "nav-item"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "nav-icon" }, "✨", -1),
            _createElementVNode("span", null, "创作", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/fan-creation",
          class: "nav-item"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("i", { class: "nav-icon" }, "🎨", -1),
            _createElementVNode("span", null, "二创", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/daughters",
          class: "nav-item"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "nav-icon" }, "👧", -1),
            _createElementVNode("span", null, "女儿们", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/merch",
          class: "nav-item"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "nav-icon" }, "🎁", -1),
            _createElementVNode("span", null, "周边", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/galgame",
          class: "nav-item"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createElementVNode("i", { class: "nav-icon" }, "🎮", -1),
            _createElementVNode("span", null, "Galgame", -1)
          ])),
          _: 1
        })
      ])
    ])
  ]))
}